import { filtersHelper } from '@/utils';
import { propertyAreaUnitModel } from '@/models/api/propertyAreaUnit.model';
import { propertyAssetModel } from '@/models/api/propertyAsset.model';

export const propertyAssetTenantModel = (data) => ({
    uuid: data.uuid,
    customer: data.customer,
    cusstomer: data.cusstomer,
    customerContact: data.customer_contact,
    rentalValuePsf: data.rental_value_psf,
    rentalValueTotal: data.rental_value_total,
    rentalDate: filtersHelper.getDateFormat(data.rental_date),
    rentalSize: data.rental_size,
    rentalSizeUnit: data.rental_size_unit ? propertyAreaUnitModel(data.rental_size_unit) : null,
    reminderDate: filtersHelper.getDateFormat(data.reminder_date),
    needReminder: data.need_reminder,
    remark: data.remark,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    property: data.property ? propertyAssetModel(data.property) : null,
});